import React from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { SVGIcon } from 'shared/ui'

import EmojiDropdown from './Dropdown'

const HoverSVGIcon = styled(SVGIcon)`
  color: ${props => props.theme.color.monochrome.mediumDark};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.primary.brand};
  }
`

export default function EmojiPicker({ className, onSelectEmoji, direction }) {
  return (
    <EmojiDropdown
      className={className}
      direction={direction || 'left'}
      key="emoji-picker"
      onSelect={onSelectEmoji}
      trigger={
        <HoverSVGIcon
          name="smiley"
          withTooltip={{ tooltip: 'Add an emoji', position: 'top' }}
          css={css`
            padding: 1px;
          `}
        />
      }
      upward
    />
  )
}
